export default { version: 'v1.3.0' };
